import {
    INVOICE_GET_OS_REQUEST_FAIL,
    INVOICE_GET_OS_REQUEST_SUCCESS,
    RESET_INVITE_OS
  } from '../action.types'
  import initialState from '../initial.state'
  
  export default (state = initialState.invoiceOrderServices, action) => {
    switch (action.type) {
      case INVOICE_GET_OS_REQUEST_SUCCESS:
        return action.payload;
      case INVOICE_GET_OS_REQUEST_FAIL:
        return state;
        case RESET_INVITE_OS:
          return initialState.invoiceOrderServices
      default:
        return state
    }
  }
  


// WEBPACK FOOTER //
// ./src/redux/invoice/invoiceOrderservices.reducer.js